// 应付费用类型：增加特殊规则字段
export const SPECIAL_RULES_OBJ = Object.freeze({
  1: '派送费比例',
  2: '时效罚款'
});
